module.exports = __webpack_public_path__ + "media/images/icons/journal-text-6376e9a763532dd9d3746b938a8b1ad1.png";